import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import "./Footer.css";
import * as React from "react";

import {
    Collapse,
    Container,
    Dropdown,
    DropdownButton,
    FormControl,
    Nav,
    NavDropdown,
    NavItem,
    NavLink,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    OverlayTrigger,
    Popover
} from 'react-bootstrap';

import { useContext, useEffect, useState } from "react";


import { Link } from "react-router-dom";
import { MainContext } from "../store/mainContext";

import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
import config from "../config.json";
export default function Footer() {
    const { connection, state, reconnection } = useContext(UserContext);
    const { devices, changed, doChanged, setDefaultDevice, setRoutePoint, setCommand } = useContext(MainContext);

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className="nav-link p-0 text-dark"
            href=""
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
            {/*&#x25bc;*/}
        </a>
    ));



    return (
        <>

            <Navbar
                bg="light"
                expand="lg"
                fixed="bottom"
                className="d-none mx-auto py-0"
                variant="light"
                id="navbarFooter">
                <div className="container-fluid">
                    <Dropdown
                        //className="navbar-nav"                  
                        drop="up"
                        onSelect={eventKey => {
                            noronServices.hideMenu();
                            if (eventKey == -1) {
                                setCommand("AddDeviceUser");
                                return;
                            }
                            setCommand(`EditDeviceShow/${eventKey}`);
                            //const deviceFind = devices.find(({ id }) => eventKey == id);
                            //setDevice(deviceFind);
                            //setEditDeviceShow(true);
                        }}
                    >
                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" >
                            <div className="row">
                                <div className="col d-flex justify-content-center">
                                    <span className="navbarIcon" >🚗</span>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col d-flex justify-content-center">
                                    <span>ردیاب</span>
                                </div>
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu id="dd" className="myDropDown" >
                            <Dropdown.Item key={"drop0"} eventKey={-1}>
                                <div className="btn btn-primary">اضافه کردن ردیاب</div>
                            </Dropdown.Item>
                            {devices.map((item, index) => (
                                <div aria-selected="false" key={index} data-rr-ui-dropdown-item="" className="dropdown-item d-flex">
                                    <Link className="customItemMenu w-100 "
                                        to="/"
                                        style={{ textDecoration: "none" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            noronServices.hideMenu();
                                            setDefaultDevice({...item, dd : Date.now()});
                                        }}>
                                        {item.icon != "" && <img src={`${config.apiUrl}/piccar/${item.icon}`} className="imgDeviceMenu" />}
                                        <span className="p-2">{item.deviceName}</span>
                                    </Link>
                                    <button className="btn btn-secondary p-2 btn-sm" onClick={(e) => {
                                        e.preventDefault();
                                        noronServices.hideMenu();
                                        // setDevice(item);
                                        //setEditDeviceShow(true);
                                        setCommand(`EditDeviceShow/${item.id}`);
                                        return false;
                                    }}>ویرایش</button>
                                </div>

                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <div className=" border-start customSeperator"></div>

                    <div className="navbar-nav">
                        <div className="nav-item text-nowrap">
                            <Link className="nav-link px-3" to="/" onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                setCommand("OilChangeShow");
                            }} >
                                <div className="row">
                                    <div className="col d-flex justify-content-center">
                                        <span className="navbarIcon" >🛠️</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col d-flex justify-content-center">
                                        <span className="fw-bold">سرویس خودرو</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>

                    <div className=" border-start customSeperator"></div>

                    <div className="navbar-nav">
                        <div className="nav-item text-nowrap">
                            <Link className="nav-link p-0 text-dark" to="/"
                                onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setCommand(`ShowReport`);
                                }} >
                                <div className="row">
                                    <div className="col d-flex justify-content-center">
                                        <span className="navbarIcon" >📊</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col d-flex justify-content-center">
                                        <span className="fw-bold">گزارش گیری</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className=" border-start customSeperator"></div>
                    <Dropdown
                        drop="up-centered"
                        //className="navbar-nav"
                        onSelect={eventKey => {
                            noronServices.hideMenu();
                            if (eventKey == 1) {
                                setCommand("ShowChangePassword");
                                return;
                            } else if (eventKey == 2) {
                                setCommand("ShowChangeProfile");
                                return;
                            }
                            else if (eventKey == 3) {
                                setCommand("ShowCredit");
                                return;
                            } else if (eventKey == 7) {
                                setCommand("logout");
                                return;
                            } else if (eventKey == 5) {
                                //CheckVersion();
                            }
                            else if (eventKey == 4) {
                                setCommand("ShowUserAccounts");
                                return;
                            }
                            else if (eventKey == 6) {
                                // e.preventDefault();
                                //e.stopPropagation();
                                reconnection();
                            }


                        }}
                    >
                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            <div className="row">
                                <div className="col d-flex justify-content-center">
                                    <span className="navbarIcon" >⚙️</span>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col d-flex justify-content-center">
                                    <span>تنظیمات کاربری</span>
                                </div>
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="myDropDown myDropDown2">
                            <Dropdown.Item eventKey={6}>
                                <span className="me-1"> ارتباط</span>
                                <span className={" badge rounded-pill " + (state == "Connected" ? "bg-success" :
                                    state == "Disconnected" ? "bg-danger" : "bg-warning")}>
                                    {state ? state : "نامشخص"}
                                </span></Dropdown.Item>
                            <Dropdown.Item eventKey={1}>تغییر رمز عبور     </Dropdown.Item>
                            <Dropdown.Item eventKey={2}>تغییر مشخصات</Dropdown.Item>
                            <Dropdown.Item eventKey={3}>تمدید اعتبار</Dropdown.Item>
                            {/* <Dropdown.Item eventKey={5}> چک کردن نسخه جدید</Dropdown.Item>*/}
                            <Dropdown.Item eventKey={4}>کاربران زیر مجموعه</Dropdown.Item>
                            <Dropdown.Item eventKey={7}> خروج</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>


                </div>
            </Navbar >
        </>
    );
}
